import type { ComponentSchema } from '../../../../../schema-types'
import { schema as base } from '../auth/signin.schema'

/** Juta sign-in: the base fields plus the title and the intro line above the phone field. */
export const schema: ComponentSchema = {
  ...base,
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'Sign in' },
    { key: 'intro', label: 'Intro text', type: 'text', default: 'Sign in or create an account with your mobile number.' },
    ...base.commonFields,
  ],
}
